import { Component, OnInit } from '@angular/core';
import { CellClassParams, GetContextMenuItemsParams, GridReadyEvent, MenuItemDef } from 'ag-grid-community';
import { StaticFields } from 'src/app/shared/staticFields';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { ApiService } from 'src/app/services/api.service';
import { LoadingService } from 'src/app/services/loading.service';
import { CustomMessageService } from 'src/app/services/custom.message.service';
import { Crop } from 'src/app/models/crop';
import { CommonService } from 'src/app/services/common.service';
import { AppConstants, ImportFileHeader } from 'src/app/shared/appconstants';
import { Germplasm } from 'src/app/models/germplasm';
import { InvalidCountComponent } from 'src/app/shared/invalidCountComponent';
import { MultiSelectComponent } from 'src/app/shared/multiSelectComponent';
import { SignalRService } from 'src/app/services/signalr.service';
import { HttpParams } from '@angular/common/http';


@Component({
  selector: 'app-import-file',
  templateUrl: './import-file.component.html',
  styleUrls: ['./import-file.component.scss']
})
export class ImportFileComponent implements OnInit {
  stages: string[] = [];
  stagesToDisplay: string[] = [];
  metaData: string[] = [];
  tagList: string[] = [];
  programs: string [] = [];
  gePrograms: string[] = [];
  fileName: any;
  importedExcelData: any[] = [];
  gridImportData: any[] = [];
  sheets: any[] = [];
  excelData: any[] = [];
  showConfirmSheet: boolean = false;
  showImportGrid: boolean = false;
  importColumnDefs: any[] = []; 
  headerCols: any[] = [];
  openImportedData: boolean = false;
  dataColDef: any [] = [];
  valDataColDef: any = [];
  rowData: any[] = [];
  dataToSubmit: any[] = [];
  selectedGeIdsData: any[] = [];
  onlyDefaultName = true;
  selectedCrop: any;  
  selectedGECrop: any;
  selectedYear : any;
  idList: string[] = [];
  displayGrid: boolean = false;
  searchBy: string = "IMPORT EXCEL";
  searchByGeIdName: string = "GE ID";
  openImportByGes : boolean = false;
  invalidIds: string[] = [];
  items: MenuItem[] | undefined;
  appendComments: boolean = true;
  appendMetadata: boolean = true;
  appendTags: boolean = true;
  createNewTags: boolean = false;
  showCreateTags: boolean = false;
  foundCell: any[] = [];
  foundIndex = 0;
  lastFoundCell: any;
  found = false;
  showFindReplace = false;
  findText: string = "";
  replaceText: string = "";
  matchCaseChecked = false;
  matchWordChecked = false;
  gridApi: any;
  geGridApi: any;
  showInfoToolTip: boolean = false; 
  onlyTags: boolean = false;
  public components: {
        [p: string]: any;
      } = {
        customMultiSelectEditor: MultiSelectComponent,
      };
  geIdColDef : any = [
    { field: 'geId', headerName: 'GE ID', minWidth: 50, width: 100},
    { field: 'geName', headerName: 'GE Name',minWidth: 50, width: 115},
    { field: 'existingVals', headerName: 'Existing Program:PStage',minWidth: 50, width: 185},
    { field: 'name', headerName: 'Program', editable: true, minWidth: 30, width: 110, 
      cellEditorSelector: () => {
        return {
          component: 'agRichSelectCellEditor',
          params: {
            values: this.gePrograms,
            searchType: 'match',
            filterList: true,
            allowTyping : true,
            highlightMatch: true,
            multiSelect: false
          }
        }
      },
      cellStyle: cellStyle,
    },
    { field: 'stage', headerName: 'PStage', cellEditor: 'agSelectCellEditor', editable: true, minWidth: 30, width: 100,
      cellEditorParams: { values: this.stagesToDisplay}, cellStyle: (p: any) => { 
        if (!this.onlyTags && !p.data.stage) {
          return {
            'border-style': 'solid',
            'border-color': 'red'
          } 
        } else {
          return {
            'border-style': 'none',
            'border-color': 'transparent'
          } 
        }
      }, },
    { field: 'comments', headerName: 'Comment',minWidth: 50, editable: true},
    { field: 'metadata', headerName: 'Metadata',minWidth: 50,editable: true, cellEditor: 'customMultiSelectEditor',
      cellEditorParams: (params : any ) => {
        return {values: this.metaData, dataSourceType: "years"}
      },
      suppressKeyboardEvent: (params : any) => {
        const key = params.event.key;
        const gridShouldDoNothing = params.editing && (key === "Enter");
        return gridShouldDoNothing;
      } 
    },
    { field: 'tag', headerName: 'Tags',minWidth: 50,editable: true, cellEditor: 'customMultiSelectEditor',
      cellEditorParams: (params : any ) => {
        return {values: this.tagList, dataSourceType: "years"}
      },
      suppressKeyboardEvent: (params : any) => {
        const key = params.event.key;
        const gridShouldDoNothing = params.editing && (key === "Enter");
        return gridShouldDoNothing;
      } 
    }
  ]
  defaultColDef = {
    sortable: true,
    filter: true,
    filterParams: { buttons: ["clear"] },
    resizable: true,
  };
  geGridOptions : any = {
    context: {
      componentParent: this,
    },
    statusBar: {
      statusPanels: [
        {
          statusPanel: 'agTotalRowCountComponent',
          align: 'right',
        }
      ]
    }
  };

  gridOptions : any = {
    popupParent: document.querySelector('body'),
    context: {
      componentParent: this,
    },
    statusBar: {
      statusPanels: [
        {
          statusPanel: 'agTotalRowCountComponent',
          align: 'left',
        },
        {
          statusPanel: InvalidCountComponent,
          //key: 'valueCompKey',
          align: 'right',
        }
      ],
    }
  };
  selectedGeIdsDataCopy: any;

  get crops(): Crop [] {
    return StaticFields.crops?.filter(ele => ele.isActive);
  }

  get years(): any [] {
    return StaticFields.years;
  }

  get mappedColCount(): number {
    const mappedCols = this.importColumnDefs.filter((c: any) => c['mappedCol']).map((c: any) => c['mappedCol']);
    return this.onlyTags ? mappedCols.length : mappedCols.filter(c => !(c.endsWith('_Comments') || c.endsWith('_MetaData') || c.endsWith('_Tags'))).length;
  }

  get tooltipText(): string {
    const mappedCols = this.importColumnDefs.filter((c: any) => c['mappedCol']).map((c: any) => c['mappedCol']);  
    if (!this.onlyTags && (mappedCols.findIndex(c => c === ImportFileHeader.geId || c === ImportFileHeader.geName) < 0 || mappedCols.findIndex(c => c === ImportFileHeader.program) < 0 || mappedCols.findIndex(c => c === ImportFileHeader.year) < 0 || mappedCols.findIndex(c => c === ImportFileHeader.stage) < 0)) {
      return "Please map GEID/Name, Program, Year, PStage ";
    } else if (this.onlyTags && (mappedCols.findIndex(c => c === ImportFileHeader.geId || c === ImportFileHeader.geName) < 0 || ((mappedCols.filter(c => c.endsWith('_Comments') || c.endsWith('_MetaData') || c.endsWith('_Tags')).length === 0) 
      && (mappedCols.findIndex(c => c === ImportFileHeader.program) < 0 || mappedCols.findIndex(c => c === ImportFileHeader.tag) < 0 || mappedCols.findIndex(c => c === ImportFileHeader.metaData) < 0 || mappedCols.findIndex(c => c === ImportFileHeader.programComment) < 0))))
      return "Please map GEID/Name, Program and Tags/Metadata/Comments";
    return "All required columns mapped.";
  }

  get submitDisabled(): boolean {
    return this.dataToSubmit.filter(p => p.IsValid === false).length === this.dataToSubmit.length;
  }

  get invalidCount(): number {
    return this.dataToSubmit.filter(p => p.IsValid === false).length;
  }

  get idListText(): string {
    return this.idList.join("\r\n");
  }

  set idListText(value) {
    this.idList = value.split(/\r?\n/);
    if (this.idList.length < 2)
      this.idList = value.split(",");
    this.idList = this.idList.filter((v, i, a) => a.indexOf(v) === i);
    this.idList = this.idList.map(s => s.toString().trim()).filter(s => s);
  }

  get invalidIdListText(): string {
    return this.invalidIds.join("\r\n");
  }

  get saveEnabledForGes() : boolean {
    return JSON.stringify(this.selectedGeIdsDataCopy) != JSON.stringify(this.selectedGeIdsData);
  }

  constructor(private confirmService: ConfirmationService, private apiService : ApiService, public loader: LoadingService, public customMessageService: CustomMessageService, public commonService : CommonService, private signalRService: SignalRService) { }

  ngOnInit(): void {
    this.items = [    
      {
          label: 'By GEID/Name',
          icon: 'pi pi-clipboard',
          command: () => this.openGeDialog()
      },
      {
          label: 'From file',
          icon: 'pi pi-folder-open',
          disabled: this.selectedCrop,
          command: () => this.importFile('importFile')
      }    
    ] ;
    if (StaticFields.appUserId) {
      this.selectedGECrop = this.selectedCrop = this.crops?.find(ele => ele.Name == StaticFields.precodePreference?.crop);
      if (this.selectedCrop) {
        this.getMasterData(false);
        this.getMetaData();
      }
    } else {
      const interval = setInterval(() => {
        if (StaticFields.appUserId) {
          clearInterval(interval);
          this.selectedGECrop = this.selectedCrop = this.crops?.find(ele => ele.Name == StaticFields.precodePreference?.crop);
          if (this.selectedCrop) {
            this.getMasterData(false);
            this.getMetaData();
          }
        }
      }, 600);
    }
    window.addEventListener("keydown", function (e) {
      if (e.key === 'f' && e.ctrlKey && (e.target as any).role === 'gridcell') { 
        e.preventDefault();
      }
    });
    const elements = document.getElementsByClassName("footer-container");
    for (let i = 0; i < elements.length; i++) {
      (elements[i] as HTMLElement).style.display = 'none';
    }
  }

  onGridReady($event: GridReadyEvent<any,any>) {
    this.gridApi = $event.api;
  }

  onGEGridReady($event: GridReadyEvent<any,any>) {
    this.geGridApi = $event.api;
  }

  importFile(input: string) {     
    if (this.selectedCrop == undefined) {
      this.customMessageService.showMessage({'severity': 'error', summary: 'Select Crop', detail: "Please Select Crop."});  
      return;
    }
    this.createNewTags = this.showCreateTags = this.onlyTags = false;
    this.appendMetadata = this.appendTags = this.appendComments = true;
    this.openFile(input); 
    this.getPrograms(false);  
  }

  openFile(input: string) {
    document.getElementById(input)?.click();
  }

  handle(event: any) {
    this.loader.setMessage('Loading...'); 
    setTimeout(() => {
      const file = event.target.files[0];
        if (typeof Worker !== 'undefined') {
          const worker = new Worker(new URL('../.././app.worker', import.meta.url), { type: 'module' });  
          worker.onmessage = ({ data }) => {
            this.fillGridWithData(data);
          };
          worker.onerror = errorEvent => {
            const formData = new FormData();
            formData.append('file', file);
            this.apiService.postData("GetDecryptedExcelFileData", formData, false).subscribe({
              next: (response: any) => {             
                this.fillGridWithData(response);              
              }           
            });
          };
          worker.postMessage(file);
          this.fileName = file.name;
          event.target.value = "";
        } else {
          console.log("Worker not supported.");
        }
    }, 600);
  }

  fillGridWithData(data: any) {
    if (data.data?.length == 0){
      this.loader.clearMessage();
      this.customMessageService.showMessage({'severity': 'error', summary: 'No Data', detail: "No Data in Imported File."}); 
      return; 
    }
    const sheets = Object.getOwnPropertyNames(data);
    if (sheets.length === 1 || (sheets.length === 2 && sheets[1] === 'hidden')) {
      this.importedExcelData =  data[<any>(sheets[0])];
      this.gridImportData = this.importedExcelData.slice(0, 15);
      this.fillGrid();
    } else if (sheets.length > 1) {
      this.loader.clearMessage();
      this.sheets = [];
      setTimeout(() => {
        sheets.forEach(s => {
          this.sheets.push({ name: s });
        });
        this.excelData = data;
        this.showConfirmSheet = true;
      }, 10);
    } else {
      this.loader.clearMessage();
      this.customMessageService.showMessage({'severity': 'error', summary: 'Invalid File', detail: "No sheet found in imported file."});  
    }
  }

  onSheetChange(args: any) {
    this.importedExcelData = this.excelData[args.value.name];
    this.gridImportData = this.importedExcelData.slice(0, 15);
    this.fillGrid();
    this.showConfirmSheet = false;
  }

  addHeaderCol(k: string, mappedColumn: string) {
    let duplicateColFound = false;
    if (this.importColumnDefs.findIndex((c: { mappedCol: string; }) => c.mappedCol === mappedColumn) > -1)
      duplicateColFound = true;
    this.importColumnDefs.push({ header: k, mappedCol: mappedColumn});
    return duplicateColFound;
  }

  addValidatedHeaderCol(header: string, field: string, memberData : boolean) {
    if (this.valDataColDef.findIndex((ele : any) => ele.headerName === header) < 0) {   
      let headerObject = {'headerName' : header, 'field' : field, tooltipField: field + 'invalidReason', valueGetter: (params : any) => {return params?.data[field];}, minWidth: 70, width: 130, resizable : true};
      this.valDataColDef.push(headerObject);
    }
  }

  fillGrid() {
    this.showImportGrid = false;  
    this.importColumnDefs.splice(0); 
    this.headerCols =  AppConstants.ImportFileHeaders;
    const header = JSON.parse(StaticFields.homeScreenData.mappingModel);
    const geIdHeaders = header.geId?.toUpperCase().split(',');
    const geNameHeaders = header.geName?.toUpperCase().split(',');
    const nameHeaders = header.programName?.toUpperCase().split(',');
    const yearHeaders = header.year?.toUpperCase().split(',');
    const stageHeaders = header.stage?.toUpperCase().split(',');
    const metaDataHeaders = header.metaData?.toUpperCase().split(',');
    const customMetaDataHeaders = header.tag?.toUpperCase().split(',');
    const ccommentHeaders = header.comments?.toUpperCase().split(',');
  
    try {
      let duplicateColFound = false;
      Object.keys(this.gridImportData[0]).forEach(k => { 
        if (this.headerCols.findIndex(c => c.toUpperCase().toString().trim() === k.toUpperCase().toString().trim()) > -1) {
          duplicateColFound = this.addHeaderCol(k, this.headerCols.find(c => c.toUpperCase().toString().trim() === k.toUpperCase().toString().trim()));
        } else {
          if (geIdHeaders?.findIndex((c: string) => c.toString().trim() === k.toUpperCase().toString().trim()) > -1)
            duplicateColFound = this.addHeaderCol(k, ImportFileHeader.geId);
          else if (geNameHeaders?.findIndex((c: string) => c.toString().trim() === k.toUpperCase().toString().trim()) > -1)
            duplicateColFound = this.addHeaderCol(k, ImportFileHeader.geName);
          else if (nameHeaders?.findIndex((c: string) => c.toString().trim() === k.toUpperCase().toString().trim()) > -1)
            duplicateColFound = this.addHeaderCol(k, ImportFileHeader.program);
          else if (yearHeaders?.findIndex((c: string) => c.toString().trim() === k.toUpperCase().toString().trim()) > -1)
            duplicateColFound = this.addHeaderCol(k, ImportFileHeader.year);
          else if (stageHeaders?.findIndex((c: string) => c.toString().trim() === k.toUpperCase().toString().trim()) > -1)
            duplicateColFound = this.addHeaderCol(k, ImportFileHeader.stage);
          else if (metaDataHeaders?.findIndex((c: string) => c.toString().trim() === k.toUpperCase().toString().trim()) > -1)
            duplicateColFound = this.addHeaderCol(k, ImportFileHeader.metaData);
          else if (customMetaDataHeaders?.findIndex((c: string) => c.toString().trim() === k.toUpperCase().toString().trim()) > -1)
            duplicateColFound = this.addHeaderCol(k, ImportFileHeader.tag);
          else if (ccommentHeaders?.findIndex((c: string) => c.toString().trim() === k.toUpperCase().toString().trim()) > -1)
            duplicateColFound = this.addHeaderCol(k, ImportFileHeader.programComment);
          else if (k.endsWith('_Comments') || k.endsWith('_MetaData') || k.endsWith('_Tags')) {
            const parts = k.split('_');
            duplicateColFound = this.addHeaderCol(k, k);
          }
          else if (!k.startsWith('Existing'))
            this.importColumnDefs.push({ header: k});
        }
      });
      this.loader.clearMessage();
      if (duplicateColFound) {
        this.customMessageService.showMessage({'severity': 'error', summary: 'Duplicate Columns', detail: "Sheet contains duplicate columns."}); 
        return;
      }
      this.showImportGrid = this.openImportedData = true;
    }
    catch (e: any) {
      this.loader.clearMessage();
      this.customMessageService.showMessage({'severity': 'error', summary: 'Load Error', detail: "Excel Load error: " + e.message}); 
    }
  }

  onHeaderSelectionChange(target: any, col: any) {
    const value = target.value.split(":")[1].toString().trim();
    if (value) {
        if (this.importColumnDefs.findIndex((c: { mappedCol: any; }) => c.mappedCol === value) > -1) {
          this.customMessageService.showMessage({'severity': 'error', summary: 'Duplicate Columns', detail:  value + " has already been mapped."}); 
          target.selectedIndex = this.headerCols.findIndex(h => h === col['mappedCol']);
        } else {
          col['mappedCol'] = value;
          col['customCol'] = '';
        }
    } else
      col['customCol'] = col['mappedCol'] = '';
  }

  markInvalid(invalidItems: any, prop: string, reason: string, isBlank?: boolean, isNotFound?: boolean) {
    invalidItems.forEach((item: any) => {
      if((prop == "GeName" && !item.GeId && !isBlank && !isNotFound) || (prop == "GeName" && item.GeId)) {
        item['IsValid'] = true;
      } else {
        item['IsValid'] = false;
        item[prop + 'classProp'] = isBlank ? "blank" : isNotFound ? "notfound" : "invalid";
      }
     
      const foundProp = this.valDataColDef.find((e: any) => e.field === prop);
      if (foundProp) {
        foundProp['cellStyle'] = (params: { data: { [x: string]: any; }; }) => {
          const className = params.data[prop + 'classProp'];
          return { backgroundColor:  className === "invalid" || className === "notfound" ? 'orange' : className === "default" ? 'transparent' : className === "blank" ? "yellow" : 'transparent' };
        }   
        item[prop + "invalidReason"] = reason ? reason : "";
      }      
    });
  } 

  onValidate() {
    if (this.tooltipText !== "All required columns mapped.") {    
      this.customMessageService.showMessage({'severity': 'error', summary: 'Unmapped Columns', detail:  this.tooltipText}); 
      return;
    }
    this.displayGrid = false;
    this.loader.setMessage('Loading...');
    this.valDataColDef.splice(0);
    this.dataToSubmit.splice(0);
    this.dataColDef = this.importColumnDefs.filter((c: { [x: string]: any; }) => c['mappedCol'] );
    const prog_Tags = this.dataColDef.map(c => c.mappedCol).filter((c: any) => c.endsWith('_Comments') || c.endsWith('_MetaData') || c.endsWith('_Tags'));
    const tagList: any = {};
    if (this.onlyTags && prog_Tags.length > 0) {
      prog_Tags.forEach(t => {
        const parts = t.split('_');
        if (!Object.keys(tagList).includes(parts[0]))
          tagList[parts[0]] = [];
        tagList[parts[0]].push(parts[1]);
      });
    }
    let col = this.dataColDef.find(d => d.mappedCol === ImportFileHeader.geId);
    if (!(col && this.importedExcelData[0][col.header]))
      col = this.dataColDef.find(d => d.mappedCol === ImportFileHeader.geName);
    let geList = this.importedExcelData.map(p => p[col.header]);
    this.apiService.postData('GetGEInfo', {cropName: this.selectedCrop.Name, geList: geList}, false).subscribe((result : any) => {
      let germplasms: Germplasm[] = result;  
      let existingGeIds: number[] = germplasms.map(p => p.geId);
      let existingGeNames: string[] = germplasms.map(p => p.name);    
      this.importedExcelData.forEach(row => {
        let item: any = {};
        col = this.dataColDef.find(d => d.mappedCol === ImportFileHeader.geId);
        if (!(col && this.importedExcelData[0][col.header]))
          col = this.dataColDef.find(d => d.mappedCol === ImportFileHeader.geName);
        if (col.mappedCol === ImportFileHeader.geId) {
          item.GeId = row[col.header] ? row[col.header].toString().trim() : row[col.header];
          this.addValidatedHeaderCol(ImportFileHeader.geId, "GeId", false);
          let geIdExists = existingGeIds.includes(Number(item.GeId)); 
          if (item.GeId == null || !geIdExists)
            this.markInvalid([item], "GeId", item.GeId == null ?  "Required" : "Ge Id Not Found In " + this.selectedCrop.Name, item.GeId == null ? true : false, !geIdExists);
        } else if (col.mappedCol === ImportFileHeader.geName){
          item.GeName = row[col.header] ? row[col.header].toString().trim() : row[col.header];
          item.GeId =  item.GeName ? germplasms.find(p => p.name == item.GeName)?.geId : item.GeId;
          this.addValidatedHeaderCol(ImportFileHeader.geName, "GeName", false);   
          let geNameExists = existingGeNames.includes(item.GeName); 
          if (item.GeName == null || !geNameExists)
            this.markInvalid([item], "GeName", item.GeName == null ?  "Required" : "Ge Name Not Found In " + this.selectedCrop.Name, item.GeName == null ? true : false, !geNameExists);
        }
        if (this.onlyTags && prog_Tags.length > 0) {
          this.addValidatedHeaderCol(ImportFileHeader.program, "Name", false);
          Object.keys(tagList).forEach(t => {
            const newItem: any = {};
            newItem.GeId = item.GeId.toString().trim();
            newItem.Name = t.toUpperCase();
            newItem.Crop = this.selectedCrop.Name;
            newItem.Stage = '';
            tagList[t].forEach((ele: string) => {
              const field = ele === "Tags" ? 'CustomMetaData' : ele;
              newItem[field] = row[`${t}_${ele}`] ? row[`${t}_${ele}`].toString().trim() : row[`${t}_${ele}`];
              this.addValidatedHeaderCol(ele, field, false);
              if (newItem[field]) {
                if (ele === "Tags") {
                  if (newItem[field].endsWith(';'))
                    newItem[field] = newItem[field].slice(0, -1);
                  newItem[field].split(';').forEach((d: string) => {
                    if (!this.tagList.includes(d) && newItem[field].toLowerCase() !== 'd' && newItem[field].toLowerCase() !== 'delete') {
                      this.showCreateTags = true;
                      this.markInvalid([newItem], "CustomMetaData", `Valid Tags setup in your preferences are: ${this.tagList.join()}. Select Create New Tags to add to your tag list.`, false);
                    }
                  });
                } else if (ele === "MetaData") {
                  if (newItem[field].endsWith(';') || newItem[field].endsWith(','))
                    newItem[field] = newItem[field].slice(0, -1);
                  let parts = newItem[field].split(';');
                  if (parts.length === 1)
                    parts = parts[0].split(',');
                  parts.forEach((d: string) => {
                    if (!this.metaData.includes(d) && newItem[field].toLowerCase() !== 'd' && newItem[field].toLowerCase() !== 'delete')
                      this.markInvalid([newItem], "MetaData", "Metadata Not Found In " + this.metaData.join(), false);
                  });
                }
              }
            });
            if (newItem["CustomMetaData"] || newItem["MetaData"] || newItem["Comments"])
              this.dataToSubmit.push(newItem);
          });
        } else {
          col = this.dataColDef.find(d => d.mappedCol === ImportFileHeader.program);
          if (col) {
            item.Name = row[col.header] ? row[col.header].toString().trim() : row[col.header];
            this.addValidatedHeaderCol(ImportFileHeader.program, "Name", false);
            let programExists = this.programs.includes(item.Name);
            if (item.Name == null || !programExists)
              this.markInvalid([item], "Name", item.Name == null ?  "Required" : "Program Not Found In " + this.selectedCrop.Name, item.Name == null ? true : false, !programExists);
          }      
          item.Crop = this.selectedCrop.Name;       
          col = this.dataColDef.find(d => d.mappedCol === ImportFileHeader.year);
          if (col) {
            item.Year = row[col.header] ? row[col.header].toString().trim() : row[col.header];
            this.addValidatedHeaderCol(ImportFileHeader.year, "Year", false);
            if (this.onlyTags)
              item.year = 0;
            else if (!item.Year || isNaN(item.Year) || item.Year.length !== 4 || Number(item.Year) < 1900)
              this.markInvalid([item], "Year", item.Year ? "Not a valid year" : "Required", row[col.header] ? false : true );
          }
          col = this.dataColDef.find(d => d.mappedCol === ImportFileHeader.stage);
          if (col) {
            item.Stage = row[col.header] ? row[col.header].toString().trim() : row[col.header];
            this.addValidatedHeaderCol(ImportFileHeader.stage, "Stage", false);
            if (this.onlyTags)
              item.Stage = '';
            else  {
              const isStageBlank = item.Stage && item.Stage.toString().trim() ? false : true;
              const stageNotFound = !this.stages.includes(item.Stage) && item.Stage !== null && item.Stage.toLowerCase() !== 'd' && item.Stage.toLowerCase() !== 'delete';    
              if (isStageBlank || stageNotFound)
                this.markInvalid([item], "Stage", isStageBlank ? "Required" : "Stage Not Found In " + this.selectedCrop.Name, isStageBlank, stageNotFound);
            }
          }
          col = this.dataColDef.find(d => d.mappedCol === ImportFileHeader.metaData);
          if (col) {
            item.MetaData = row[col.header] ? row[col.header].toString().trim() : row[col.header];
            this.addValidatedHeaderCol(ImportFileHeader.metaData, "MetaData", false);
            if (item.MetaData) {
              if (item.MetaData.endsWith(';') || item.MetaData.endsWith(','))
                item.MetaData = item.MetaData.slice(0, -1);
              let parts = item.MetaData.split(';');
              if (parts.length === 1)
                parts = parts[0].split(',');
              parts.forEach((d: string) => {
                if (!this.metaData.includes(d) && item.MetaData.toLowerCase() !== 'd' && item.MetaData.toLowerCase() !== 'delete')
                  this.markInvalid([item], "MetaData", "Metadata Not Found In " + this.metaData.join(), false);
              });
            }
          }
          col = this.dataColDef.find(d => d.mappedCol === ImportFileHeader.tag);
          if (col) {
            item.CustomMetaData = row[col.header] ? row[col.header].toString().trim() : row[col.header];
            this.addValidatedHeaderCol(ImportFileHeader.tag, "CustomMetaData", false);  
            if (item.CustomMetaData) {
              if (item.CustomMetaData.endsWith(';'))
                item.CustomMetaData = item.CustomMetaData.slice(0, -1);
              item.CustomMetaData.split(';').forEach((d: string) => {
                if (!this.tagList.includes(d) && item.CustomMetaData.toLowerCase() !== 'd' && item.CustomMetaData.toLowerCase() !== 'delete') {
                  this.showCreateTags = true;
                  this.markInvalid([item], "CustomMetaData", `Valid Tags setup in your preferences are: ${this.tagList.join()}. Select Create New Tags to add to your tag list.`, false);
                }
              });
            }         
          }     
          col = this.dataColDef.find(d => d.mappedCol === ImportFileHeader.programComment); 
          if (col) {
            item.Comments = row[col.header] ? row[col.header].toString().trim() : row[col.header];
            this.addValidatedHeaderCol(ImportFileHeader.programComment, "Comments", false);      
          }
          if (this.dataToSubmit.findIndex(d => d.Name === item.Name && d.Year === item.Year && d.Stage === item.Stage && (item.GeId && d.GeId === item.GeId || (item.GeName && d.GeName === item.GeName && d.Crop === item.Crop))) > -1)
            this.markInvalid([item], "Name", `Duplicate ${item.GeName ? `${item.Crop}, ${item.GeName}` : `${item.GeId}`}, ${item.Name}, ${item.Year}, ${item.Stage} combination found.`, false);
          if ((item.GeId || item.GeName) && item.Name)
            this.dataToSubmit.push(item);
        }
      });
      this.showImportGrid = this.openImportedData = false;
      this.displayGrid = true;
      this.rowData = this.dataToSubmit;
      this.signalRService.startWebAppConnection();
      this.signalRService.addResponseServerToClientListener();
      this.loader.clearMessage();    
    });    
  }

  toggleTags(event: any) {
    if (event.checked) {
      this.updateCellAfterValidation("CustomMetaData", this.dataToSubmit);
    } else {
      this.displayGrid = false;
      setTimeout(() => {
        this.dataToSubmit.forEach((item) => {
          if (item.CustomMetaData) {
            item.CustomMetaData.split(';').forEach((d: string) => {
              if (!this.tagList.includes(d)) {
                this.markInvalid([item], "CustomMetaData", `Valid Tags setup in your preferences are: ${this.tagList.join()}. Select Create New Tags to add to your tag list.`, false);
              }
            });
          }
        });
        this.displayGrid = true;
      }, 0);
    }
  }

  refreshStageCol(event: any) {
    if (this.geGridApi)
      this.geGridApi.redrawRows();
  }

  updateCellAfterValidation(col: string, data: any) {
    this.displayGrid = false;
    setTimeout(() => {
      const foundProp = this.valDataColDef.find((e: any) => e.field === col);
      if (foundProp) {
        if (data.length > 1)
          delete foundProp['cellStyle'];
        data.filter((d: any) => d.IsValid === false && d[`${col}invalidReason`]).forEach((td: any) => {
          delete td[`${col}invalidReason`];
          delete td[`${col}classProp`];
          td.IsValid = Object.keys(td).filter(col => col.endsWith("invalidReason")).length === 0;
        });
      }
      this.displayGrid = true;
    }, 0);
  }

  exportTemplate() {
    this.commonService.generateExcel(this.metaData, this.tagList, this.stages);
  }

  reset() {
    if (this.dataToSubmit.length > 0 && this.displayGrid) {
      this.confirmService.confirm({
        header : 'Confirm',
        message: 'All changes will be lost',
        accept: () => {        
          this.refreshPage();
        }
      });
    } else 
      this.refreshPage();
  }

  refreshPage(retainColDef?: boolean) {
    if (!retainColDef) {
      this.valDataColDef.splice(0);
    }
    this.displayGrid = false;
    this.dataToSubmit.splice(0);
    this.importColumnDefs.splice(0);
    this.dataColDef.splice(0);
    this.showCreateTags = this.showConfirmSheet = this.onlyTags = false;
    this.appendMetadata = this.appendTags = this.appendComments = true;
    this.sheets.splice(0);
    this.getMasterData(false);
    this.getMetaData();
  }

  getMasterData(isGe? : boolean) {  
    const crop = isGe ? this.selectedGECrop.Name : this.selectedCrop.Name;
    this.stages.splice(0);
    this.stagesToDisplay.splice(0);
    StaticFields.masterData?.filter(p => p.type == 'Stage' && p.crop == crop && p.isActive).forEach((s: any) => {   
    if (s.stage && !this.stages.includes(s.stage)){      
      this.stages.push(s.stage);
      this.stagesToDisplay.push(s.stage);
    }
    if (s.nextStage && !this.stages.includes(s.nextStage)){
      this.stages.push(s.nextStage);
      this.stagesToDisplay.push(s.stage);
    }});
    this.stagesToDisplay.push('d');
    if (isGe)
      this.getPrograms(true);
  } 

  getMetaData() {
    this.metaData = StaticFields.metaData?.filter(p => (p.crop.toUpperCase() === "ALL" || p.crop === this.selectedCrop.Name) && p.isActive).map((d: any) => d.name).sort((a: any, b: any) => (a > b) ? 1 : ((b > a) ? -1 : 0));
    this.tagList.splice(0);
    if (StaticFields.precodePreference?.tags) {
      const tagParts = StaticFields.precodePreference.tags.split(";");
      tagParts.forEach((t: any) => {
        const parts = t.split(':');
        if (parts[1] === 'true')
          this.tagList.push(parts[0]);
      });
    } 
  } 

  getPrograms(isGe: boolean) {  
    const crop = isGe ? this.selectedGECrop.Name : this.selectedCrop.Name;
    //this.apiService.getRADData(`Programs?$filter=CropId eq ${cropId} and Status/Name eq 'Active'&$select=Id,Code`, false).subscribe((result : any) => {
    let selectCountry = '';
    if (StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0)
      selectCountry = ',CountryName';
    this.apiService.getOData(`ProgramPreferences?$filter=CropName eq '${crop}' and IsActive&$select=Id,Code,Description${selectCountry}`).subscribe((result : any) => {
      if (StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0)
        result.value = result.value.filter((r: any) => StaticFields.countriesToShow.includes(r.countryName.toUpperCase()));
      if (isGe)
        this.gePrograms = result.value.sort((a: any , b: any) => a.code.localeCompare(b.code)).map((r: any) => r.code);
      else 
        this.programs = result.value.sort((a: any , b: any) => a.code.localeCompare(b.code)).map((r: any) => r.code);
    });   
  }

  showInvalidRows(args: any) {
    if (args.checked) {
      this.rowData = this.dataToSubmit.filter((ele : any) => ele.IsValid === false);
    } else
      this.rowData = this.dataToSubmit;
  }

  submit() {
    const invalidValues = this.dataToSubmit.filter((ele : any) => ele.IsValid === false);
    if (invalidValues.length > 0) {
      this.confirmService.confirm({
        header : 'Confirm',
        message: 'The imported data contains invalid values. Do you want to proceed with submitting valid values?',
        accept: () => {
          this.submitExcel();
        }
      });
    } else {
      this.submitExcel();
    }
  }

  submitExcel() {
    if (!this.submitDisabled) {     
      const validData = this.dataToSubmit.filter((ele : any) => ele.IsValid !== false);
      const excelData = {Programs: validData, appendComments: this.appendComments, appendMetadata: this.appendMetadata, appendTags: this.appendTags, createNewTags: this.createNewTags, appUserId: StaticFields.appUserId, signalRConnectionId: SignalRService.SignalRConnectionId }
      this.apiService.putData("SubmitImportFileData", excelData).subscribe((res: any) => {  
        const invalidData = this.dataToSubmit.filter((ele : any) => ele.IsValid === false);   
        this.refreshPage(invalidData.length > 0);
        if (invalidData.length > 0) {
          setTimeout(() => {
            this.displayGrid = true;
            this.dataToSubmit = this.rowData = invalidData;
            this.customMessageService.showMessage({'severity': 'warn', summary: 'Invalid Data', detail: "Grid has invalid data that was not submitted. You can export using grid menu."});  
          }, 2000);
        }
        if (this.createNewTags) {
          let params = new HttpParams();
          params = params.append('type', 'PreCode');
          params = params.append('appUserId', StaticFields.appUserId);
          this.apiService.getData('GetPreferences', params, false).subscribe((res: any) => {
            StaticFields.precodePreference = res;
          });
        }
      });            
    }
  }

  openGeDialog() {
    this.appendMetadata = this.appendTags = this.appendComments = true;
    if (this.selectedGECrop)
      this.getMasterData(true);
    this.onlyTags = false;
    this.openImportByGes = true;
  }

  fill(params: any, fillType: string) {
    if (fillType === "down" || fillType === "up") {
      let idx = params.node.rowIndex;
      params.api.forEachNodeAfterFilterAndSort((rowNode: any) => {
        if (fillType === "up" ? idx > rowNode.childIndex : idx < rowNode.childIndex) {          
          rowNode.data[params.column.colId] = params.value;
        }
      });
    } else if (fillType === "selected") {
      params.api.getSelectedRows().forEach((rowNode: any) => {       
        rowNode[params.column.colId] = params.value;
      });
    }
    params.api.refreshCells(params);
  }

  getContextMenuItems(params: GetContextMenuItemsParams): (string | MenuItemDef)[] {
    const result: (string | MenuItemDef)[] = [
      {
        name: 'Fill Up',
        disabled: !(params.value && params.node.rowIndex > 0) || !params.context.componentParent.geIdColDef.find((c: any) => c.field === params.column.getColId()).editable,
        action: function () { params.context.componentParent.fill(params, "up"); },
      },
      {
        name: 'Fill Down',
        disabled: !(params.value && params.node.rowIndex < params.context.componentParent.selectedGeIdsData.length) || !params.context.componentParent.geIdColDef.find((c: any) => c.field === params.column.getColId()).editable,
        action: function () { params.context.componentParent.fill(params, "down"); }
      },
      // {
      //   name: 'Fill Selected',
      //   disabled: !(params.value && params.api.getSelectedRows().length > 1),
      //   action: function () { params.context.componentParent.fill(params, "selected"); }
      // },
      'copy',
      'copyWithHeaders',
      'separator',
      'export'
    ]
    return result;
  }

  onGeCropChange() {    
    if (this.selectedGeIdsData.length > 0) {
      this.confirmService.confirm({
        header : 'Confirm',
        message: "You may lose all the changes made, are you sure you want to change the crop without saving ?",
        accept: () => { 
          this.selectedGeIdsData = [];     
          this.selectedGeIdsDataCopy = [];
          this.getMasterData(true);
          this.getMetaData();
        }
      })
    } else {
      this.selectedGeIdsData = [];     
      this.selectedGeIdsDataCopy = [];
      this.getMasterData(true);
      this.getMetaData();
    }
  }

  onYearChange() {
    if(this.selectedGeIdsData.length > 0) {
      this.confirmService.confirm({
        header : 'Confirm',
        message: "You may lose all the changes made, are you sure you want to change the year without saving?",
        accept: () => { 
          this.selectedGeIdsData = []; 
          this.selectedGeIdsDataCopy = [];    
        }
      })
    } else {
      this.selectedGeIdsData = []; 
      this.selectedGeIdsDataCopy = [];    
    }
  }

  resetGeImportScreen() {
    this.selectedGECrop = this.crops?.find(ele => ele.Name == StaticFields.precodePreference?.crop);
    this.selectedYear = null;
    this.idList = [];
    this.selectedGeIdsData = [];
    this.selectedGeIdsDataCopy = [];
    this.appendMetadata = this.appendTags = this.appendComments = true;
    this.invalidIds = [];
  }

  getDataByGes() {
    let gesToImport : any =[];
    let postData : any = {};
    postData['cropName'] = this.selectedGECrop.Name;
    if (this.searchByGeIdName == "GE NAME") {
      postData['geList'] = this.idList;  
      gesToImport = this.idList    
    } else {
      gesToImport = postData['geList'] = this.idList.filter(id => !isNaN(Number(id))).map(id => Number(id));
      if (gesToImport.length === 0) {
        this.customMessageService.showMessage({severity:'warn',summary: 'Invalid',detail:'GeId(s) can be numeric only.'});
        return;
      }
    }
    postData['year'] = this.selectedYear;
    this.apiService.postData("GetProgramsListByGEs", postData, false,true).subscribe({
      next: (response: any) => {       
        const data = this.selectedGeIdsData.splice(0);
        this.invalidIds = response.invalidGes.map((num : any) => num.toString());
        gesToImport.forEach((id:any) => {
          if (data.findIndex(ge => this.searchByGeIdName == "GE NAME" ? ge.geName === id : ge.geId === id) === -1) {
            const foundData = response.refinedResult.find((d: any) => this.searchByGeIdName == "GE NAME" ? d.geName === id : d.geId === id );
            if (foundData)
              data.push(foundData);
            // else if(!this.invalidIds.includes(id.toString()))
            //   data.push({geId: id,name:"",stage:"",comments:"",metadata:"",geName:"",customMetaData:""});
          }
        });
        this.selectedGeIdsData = [...data];       
        this.selectedGeIdsDataCopy = JSON.parse(JSON.stringify(this.selectedGeIdsData));
        if (data.length === 0)
          this.customMessageService.showMessage({severity:'warn',summary: 'Not Found',detail:'No Matching GE(s) Found.'});
      }
    });
    if (!SignalRService.SignalRConnectionId) {
      this.signalRService.startWebAppConnection();
      this.signalRService.addResponseServerToClientListener();
    }
  }

  submitFetchedProgramsByGes() {
    let data : any = [];
    this.selectedGeIdsData.forEach(ele => {
      let item : any= new Object();
      item.GeId = ele.geId;
      item.Name = ele.name;
      item.Year = this.onlyTags ? 0 : this.selectedYear;
      item.Stage = this.onlyTags ? '' : ele.stage;
      item.MetaData = ele.metadata ? ele.metadata.join() : null;
      item.CustomMetaData = ele.tag ? ele.tag.join(';') : null;
      item.Comments = ele.comments;
      item.Crop = this.selectedGECrop.Name;
      data.push(item);
    })
    const validData = data.filter((ele : any) => { 
      let isValid: boolean = ele.Name ? true : false;
      if (isValid)
        isValid = ele.Stage ? true : (this.onlyTags ? (ele.Comments || ele.MetaData || ele.CustomMetaData) : false);
      return isValid;
    });
    if (data.length - validData.length > 0) {
      const msg = this.onlyTags ? 'Tags/Metadata/Comments' : 'pstage';
      this.confirmService.confirm({
        header:'Confirm',
        message: `There are ${data.length - validData.length} invalid row(s) which have missing program or ${msg}. Do you want to submit valid rows?`,
        accept : () => {
          const dataToSubmit = {Programs: validData, appendComments: this.appendComments, appendMetadata: this.appendMetadata, appendTags: this.appendTags, createNewTags: false, appUserId: StaticFields.appUserId, signalRConnectionId: SignalRService.SignalRConnectionId };
          this.apiService.putData("SubmitImportFileData", dataToSubmit, false, true).subscribe((res: any) => {         
            this.openImportByGes = false;
            this.resetGeImportScreen();
            this.selectedGECrop = this.selectedCrop = this.crops?.find(ele => ele.Name == StaticFields.precodePreference?.crop);
            //this.customMessageService.showMessage({severity:'success',summary: 'Data Submitted',detail:'Data for selected GE(s) has been submitted'})
          }); 
        }
      })
    } else {
      const dataToSubmit = {Programs: validData, appendComments: this.appendComments, appendMetadata: this.appendMetadata, appendTags: this.appendTags, createNewTags: false, appUserId: StaticFields.appUserId, signalRConnectionId: SignalRService.SignalRConnectionId };
      this.apiService.putData("SubmitImportFileData", dataToSubmit, false, true).subscribe((res: any) => {      
        this.openImportByGes = false;
        this.resetGeImportScreen();
        this.selectedGECrop = this.selectedCrop = this.crops?.find(ele => ele.Name == StaticFields.precodePreference?.crop);
        //this.customMessageService.showMessage({severity:'success',summary: 'Data Submitted',detail:'Data for selected GE(s) has been submitted'})
      }); 
    }
    
  }
  
  onCellKeyDown($event: import("ag-grid-community").CellKeyDownEvent<any,any>|import("ag-grid-community").FullWidthCellKeyDownEvent<any,any>) {
    let e = $event.event as unknown as KeyboardEvent;
    if (e.key === 'f' && e.ctrlKey) {
      const focusedCell = this.gridApi.getFocusedCell();
      const rowNode = this.gridApi.getDisplayedRowAtIndex(focusedCell.rowIndex);
      const val = this.gridApi.getValue(focusedCell.column.colId, rowNode)
      this.findText = val ? val.toString() : '';
      this.showFindReplace = true;
    }    
  }

  find(clearFoundDataWhenDone: boolean) {
    let found = false;
    let rowNodes: any = [];
    let focusedCell = this.gridApi.getFocusedCell();
    if (focusedCell || this.lastFoundCell) {
      const rowIdx = this.lastFoundCell ? this.lastFoundCell.rowIndex : focusedCell.rowIndex;
      const field = this.lastFoundCell ? this.lastFoundCell.field : focusedCell.column.colId;
      let lastFoundObj: any;
      if (this.foundCell.length > 0) {
        lastFoundObj = this.foundCell[this.foundCell.length - 1];
        if (!(lastFoundObj.rowIndex == rowIdx && lastFoundObj.field == field)) {
          this.foundCell = [];
          this.foundIndex = focusedCell.rowIndex;
        }
      }
    }
    this.gridApi.forEachNode((node: any) => {
      rowNodes.push(node);
    });
    for (let i=this.foundIndex; i < rowNodes.length ; i++) {
      let node = rowNodes[i];
      var rowObj = node.data;
      found = false;
      for (var key in rowObj) {
        if (this.matchWordChecked && rowObj[key] && (this.matchCaseChecked ? rowObj[key].toString() === this.findText : rowObj[key].toString().toUpperCase() === this.findText.toUpperCase()) 
            && !this.foundCell.find(c => c.field === key && c.rowIndex === node.rowIndex)) {
          found = true;
          this.foundCell.push({ 'field': key, 'rowIndex': node.rowIndex});
          break;
        } else if (!this.matchWordChecked && rowObj[key] && (this.matchCaseChecked ? rowObj[key].toString().includes(this.findText) : rowObj[key].toString().toUpperCase().includes(this.findText.toUpperCase())) 
            && !this.foundCell.find(c => c.field === key && c.rowIndex === node.rowIndex)) {
          found = true;
          this.foundCell.push({ 'field': key, 'rowIndex': node.rowIndex});
          break;
        }
      }
      if (found) {
        break;
      }
    }
    if (found) {
      this.lastFoundCell = this.foundCell[this.foundCell.length-1];
      if (clearFoundDataWhenDone) {
        this.gridApi.ensureIndexVisible(this.lastFoundCell.rowIndex, 'middle');
        this.gridApi.ensureColumnVisible(this.lastFoundCell.field);
        this.gridApi.setFocusedCell(this.lastFoundCell.rowIndex, this.lastFoundCell.field);
      }
      this.found = true;
    } else {
      if (this.foundCell.length === 0)
        this.customMessageService.showMessage({'severity': 'warn', summary: 'Not Found', detail: 'No match found' });
      else if (clearFoundDataWhenDone)
        this.customMessageService.showMessage({'severity': 'info', summary: 'No more matches', detail: 'Reached end of Grid. Click find to search again.' });
      this.foundIndex = 0;
      if (clearFoundDataWhenDone)
        this.foundCell = [];
      this.found = false;
      this.lastFoundCell = null;
    }
  }
  
  replace(isReplaceAll: boolean) {
    if (this.found || isReplaceAll) {
      let focusedCell: any;
      var cell: any;
      let rowNodes: any[] = [];
      focusedCell = this.gridApi.getFocusedCell();
      if (focusedCell) {
        cell = { rowIndex: focusedCell.rowIndex, field: focusedCell.column.colId };
      } else {
        cell = this.foundCell[this.foundCell.length - 1];
      }
      this.gridApi.forEachNode((node: any) => {
        rowNodes.push(node);
      });
      var rowNode: any;
      var newCellValue: any = "";
      if (isReplaceAll) {
        this.foundCell = [];
        this.found = true;
        while (this.found) {
          this.find(false);
        }
        let allfoundCell = this.foundCell;
        const rowsToValidate = [];
        for (var i = 0; i < allfoundCell.length; i++) {
          cell = allfoundCell[i];
          rowNode = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex);
          const val = this.gridApi.getValue(cell.field, rowNode)
          const currentCellValue = val ? val.toString() : '';
          let splitChar = ',';
          let arrList = this.metaData;
          if (cell.field === "CustomMetaData") {
            splitChar = ';';
            arrList = this.tagList;
          } else if (cell.field === "Stage")
            arrList = this.stages;
          const vals = currentCellValue.split(splitChar);
          const findTextValid = cell.field === "Comments" ? (this.matchCaseChecked ? currentCellValue.includes(this.findText) : currentCellValue.toUpperCase().includes(this.findText.toUpperCase())) : (this.matchCaseChecked ? vals.includes(this.findText) : vals.findIndex((v: string) => v.toUpperCase() === this.findText.toUpperCase()) > -1);
          const replaceTextValid = cell.field === "Comments" || arrList.includes(this.replaceText) || this.replaceText === "";
          if (rowNode && (cell.field === "Comments" || cell.field === "Stage" || cell.field === "MetaData" || cell.field === "CustomMetaData") && findTextValid && replaceTextValid) {
            if (this.matchCaseChecked)
              newCellValue = currentCellValue.replace(this.findText, this.replaceText);
            else {
              let pattern = new RegExp(this.findText, 'gi');
              newCellValue = currentCellValue.replace(pattern, this.replaceText);
            }
            if (typeof rowNode.data[cell.field] === 'number' && Number(newCellValue))
              newCellValue = Number(newCellValue);
            rowNode.setDataValue(cell.field, newCellValue);
            rowsToValidate.push(rowNode.data);
          }
        }
        this.foundCell = [];
        this.found = false;
        if (allfoundCell.length > 0) {
          this.customMessageService.showMessage({'severity': 'info', summary: 'Replaced', detail: `Replaced ${rowsToValidate.length} matches` });
          this.updateCellAfterValidation(cell.field, rowsToValidate);
        }
      } else {
        rowNode = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex);
        const val = this.gridApi.getValue(cell.field, rowNode)
        const currentCellValue = val ? val.toString() : '';
        let splitChar = ',';
        let arrList = this.metaData;
        if (cell.field === "CustomMetaData") {
          splitChar = ';';
          arrList = this.tagList;
        } else if (cell.field === "Stage")
          arrList = this.stages;
          const vals = currentCellValue.split(splitChar);
          const findTextValid = cell.field === "Comments" ? (this.matchCaseChecked ? currentCellValue.includes(this.findText) : currentCellValue.toUpperCase().includes(this.findText.toUpperCase())) : (this.matchCaseChecked ? vals.includes(this.findText) : vals.findIndex((v: string) => v.toUpperCase() === this.findText.toUpperCase()) > -1);
          const replaceTextValid = cell.field === "Comments" || arrList.includes(this.replaceText) || this.replaceText === "";
          if ((cell.field === "Comments" || cell.field === "Stage" || cell.field === "MetaData" || cell.field === "CustomMetaData") && findTextValid && replaceTextValid) {
          if (this.matchCaseChecked)
            newCellValue = currentCellValue.replace(this.findText, this.replaceText);
          else {
            let pattern = new RegExp(this.findText, 'gi');
            newCellValue = currentCellValue.replace(pattern, this.replaceText);
          }

          if (newCellValue != rowNode.data[cell.field].toString()) {
            if (typeof rowNode.data[cell.field] === 'number' && Number(newCellValue))
              newCellValue = Number(newCellValue);
            rowNode.setDataValue(cell.field, newCellValue);
            this.updateCellAfterValidation(cell.field, [rowNode.data]);
          }
        }
        this.find(true);
      }
    }
  }
}

function cellStyle(params: CellClassParams) {
    if (!params.data.name) {
      return {
        'border-style': 'solid',
        'border-color': 'red'
      } 
    } else {
      return {
        'border-style': 'none',
        'border-color': 'transparent'
      } 
    }
 
}